import axios from "axios"
import { useAuthStore } from "@/store/modules/auth"
import { useProjectStore } from "@/store/modules/project"

const state = () => ({
  services: [],
  service: {},
  serviceCounter: {}
})
const mutations = {
  setServices(state, userData) {
    state.services = userData.services
  },
  setService(state, userData) {
    state.service = userData.service
  },
  setServiceCounter(state, userData) {
    state.serviceCounter = userData.serviceCounter
  }
}
const actions = {
  getServices({ commit, rootState }, projectId, technology) {
    const projectStore = useProjectStore()
    return axios
      .get(
        `${process.env.VUE_APP_API}/projects/${projectId || projectStore.selectedProject?.projectId}/services${
          technology ? "/technology" : ""
        }?limit=1000`
      )
      .then((result) => {
        if (result.data.data.length > 0) {
          commit("setServices", {
            services: result.data.data
          })
          commit("setService", {
            service: result.data.data[0]
          })
        } else {
          commit("setServices", {
            services: {}
          })
          commit("setService", { service: {} })
        }
        console.log("getServices() - end")
        return true
      })
      .catch(() => {
        return true
      })
  },
  getLoraServices({ commit, rootState }, projectId) {
    const projectStore = useProjectStore()
    return axios
      .get(
        `${process.env.VUE_APP_API}/projects/${projectId || projectStore.selectedProject.projectId}/services/lora?limit=1000`
      )
      .then((result) => {
        if (result.data.data.length > 0) {
          commit("setServices", {
            services: result.data.data
          })
          commit("setService", {
            service: result.data.data[0]
          })
        } else {
          commit("setServices", {
            services: {}
          })
          commit("setService", { service: {} })
        }
        return true
      })
      .catch(() => {
        return true
      })
  },
  getServiceCounter({ commit, state }) {
    axios
      .get(process.env.VUE_APP_API + "/services/" + state.service.custServiceId)
      .then((result) => {
        commit("setServiceCounter", {
          serviceCounter: result.data.data[0]
        })
      })
      .catch(() => {})
  }
}
const getters = {
  services: state => {
    return state.services.length ? state.services : [];
  },
  service: (state) => {
    return state.service
  },
  serviceCounter: (state) => {
    return state.serviceCounter
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
